import { Box, BoxProps } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React from "react";
import { BaseFieldProps, FieldWrapper } from "../FieldWrapper/FieldWrapper";
import JoditEditor, { IJoditEditorProps } from "jodit-react";

interface HtmlTextAreaProps extends BaseFieldProps {
  boxProps?: BoxProps;
}

export const HtmlTextArea = ({
  name,
  label,
  id,
  helperText,
  boxProps,
  horizontal,
}: HtmlTextAreaProps) => {
  const { setFieldValue } = useFormikContext();

  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      helperText={helperText}
      horizontal={horizontal}
    >
      {({ field }) => (
        <Box bg="white" w="100%" {...boxProps}>
          <JoditEditor
            value={field.value == null ? "" : field.value}
            onChange={(value) => setFieldValue(field.name, value)}
          />
        </Box>
      )}
    </FieldWrapper>
  );
};
